/**
 * @generated SignedSource<<0ee0ab9c6e0ec498dd072ebe49ab4850>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type freeTextFieldComponent_viewer$data = {
  readonly id: string;
  readonly " $fragmentType": "freeTextFieldComponent_viewer";
};
export type freeTextFieldComponent_viewer$key = {
  readonly " $data"?: freeTextFieldComponent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"freeTextFieldComponent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "freeTextFieldComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "86070892a6dab04d87639c3e6fa3ea10";

export default node;
